'use client';

import dynamic from 'next/dynamic';

export const PricingShowcasePreviewController = dynamic(() =>
  import('./presentation').then(
    (module) => module.PricingShowcasePreviewController
  )
);

export const PricingShowcaseRuntimeController = dynamic(() =>
  import('./presentation').then(
    (module) => module.PricingShowcaseRuntimeController
  )
);
